import { Collection } from "@tanstack/db";
import { useEffect, useState } from "react";

export function useCollectionReady(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collection: Collection<any, any, any, any, any>,
): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    collection.toArrayWhenReady().then(() => setReady(true));
  }, [collection]);

  return ready;
}
